import { useHttpClient } from "@/common/api/httpClient";
import type { ProductGroupResponse } from "./productGroupResponse";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import { storeToRefs } from "pinia";
import { useProductGroupStore } from "shared/products/groups/stores/productGroupStore";

export interface UpdateProductGroupRequest {
  groupId: string;
  group: ProductGroup;
}

interface ProductGroup {
  name?: string;
  description?: string;
  color?: string|null;
}

export interface UpdateProductGroupResponse {
  ok: true;
  group: ProductGroupResponse;
}

export function useUpdateProductGroup() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);
  const store = useProductGroupStore();

  return {
    execute
  };

  async function execute(action: UpdateProductGroupRequest) {
    const {
      group,
      groupId
    } = action;

    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`product/group/${groupId}`), {
      method: 'PUT',
      headers,
      body: JSON.stringify(group)
    });

    const text = translations.value.productGroups.actions.update;

    const response = await httpClient.action<UpdateProductGroupResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = await response.json() as ProductGroupResponse;
        store.add(json);
        return {
          ok: true,
          group: json
        };
      },
    });

    return response;
  }
}
